<template>
	<div>
		<div style="width:100px;height:100px;"><el-button type="primary" @click="getsheet">获取工作表数据</el-button></div>
		<!-- <div style="width:100px;height:100px;"><el-button type="primary" @click="GetContent">获取文本</el-button></div> -->
		<div id="luckysheet" style="margin:0px;padding:0px;position:absolute;width:100%;left: 0px;top: 50px;bottom: 0px;outline: none;"></div>
		<!-- <div id="editor" ref="editor" style="margin-top:-10px" class="diveditor"></div> -->
	</div>
</template>
<!-- <link rel='stylesheet' href='../../../public/static/plugins/css/pluginsCss.css' />
<link rel='stylesheet' href='../../../public/static/plugins/plugins.css' />
<link rel='stylesheet' href='../../../public/static/css/luckysheet.css' />
<link rel='stylesheet' href='../../../public/static/assets/iconfont/iconfont.css' />
<script src="../../../public/static/plugins/js/plugin.js"></script>	
<script src="../../../public/static/luckysheet.umd.js"></script> -->
<script>
//import $ from 'jquery'
//import E from 'wangeditor';
import tableui from '@/components/table/tablegrid_expand.vue';
//import tableson from '@/components/table/tablegrid.vue';
export default {
	name: 'editor',
	components: {
		tableui,
		//LuckyExcel
	},
	data() {
		return {
			expands: [],
			content:'',
			goods_introduce:'',
			rowkey: 'index',
			editorOption: {},
			istop: false,
			isexpand: true,
			loading: false,
			gridheight: '600px',
			editor: {},
			visible:false,
			showdel:false
		};
	},
	mounted() {
		//var that=this;
		//this.$refs.packagetable.init({list:this.packagelist,isrefresh:true});
		// this.packagelist.forEach(e=>{
		// 	that.getExpendsRow(e,that.isexpand);
		// });
		//$(function () {
			var options = {
				container: 'luckysheet' ,//luckysheet为容器id
				column:'24',
				row:'20',
				lang:'zh',
				showtoolbar:false,
				rowHeaderWidth:0,
				columnHeaderHeight:0,
				showinfobar:false,
				sheetFormulaBar:false,
				enableAddRow:false,
				enableAddBackTop:false,
				showsheetbar:false,
				showstatisticBar:false,
				data:[{"name": "Sheet1", color: "", "status": "1",celldata: [
        {
          r: 0, // 行
          c: 0, // 列
          v: "姓名\n张三", // 值
        }]}]
			 }
			 luckysheet.create(options);
			//this.initEditor();
		//});
		// this.$nextTick(function(){
		// 	debugger
		// 	var options = {
		// 		container: 'luckysheet' //luckysheet为容器id
		// 	 }
		// 	luckysheet.create(options);
		// });
		
	},
	methods: {
		initEditor() {
			var html='';
			this.editor = new E(this.$refs.editor);
			this.editor.config.height =200;
			this.editor.config.excludeMenus = ['emoticon','image', 'video', 'undo', 'redo', 'todo'];
			this.editor.config.showLinkImg = false;
			//this.editor.config.placeholder =this.baojia_air_lang.remarkplaceholder;
			this.editor.create();
			if(html!=undefined)
				this.editor.txt.html(html);
		},
		getsheet(){
			debugger
			var list=luckysheet.getSheetData();
			
		},
		showtips(){
			var newWindow = window.open();
			setTimeout(function(){
				newWindow.location.href='https://services.paytrail.com/payments/5435345345435';
			},3000);
		},
		showpopover(){
			this.showtips();
			//this.visible=true;
			//debugger
			//this.$refs.bb.handleClick();
		},
		setshowdel(){
			this.showdel=true;
			this.showpopover();
		},
		// getLength(object) {
		//     var count = 0;
		//     for(var i in object) count++;
		//     return count;
		// },
		
		GetContent(){
			debugger
			var html=this.editor.txt.html();

			console.log('内容',html);
		},
		addnewrow() {
			//	debugger
			//this.packagelist=this.packagelist.concat(JSON.parse(JSON.stringify(this.addlist)));
			this.addlist.index = this.packagelist.length + 1;
			this.$refs.packagetable.init({ list: this.addlist, isrefresh: false });
			//this.packagelist.push(JSON.parse(JSON.stringify(this.addlist)));
			//var that=this;
			//var index=this.packagelist.length-1;
			//this.getExpendsRow(this.packagelist[index],this.isexpand);
			// this.$nextTick(function() {
			// 	that.$refs.packagetable.getExpends(index, that.isexpand);
			// 	//console.log('list',JSON.stringify(that.packagelist));
			// });
		},
		gridhandle(e) {
			console.log('gridhandle', e);
		},
		checkboxchange(e) {
			console.log('checkboxchange', e);
		},
		gridscroll(e) {
			//debugger
			const scrollDistance = e.event.target.scrollHeight - e.e.scrollTop - e.event.target.offsetHeight;
			// if (scrollDistance <= 84) {
			// 	var that = this;
			// 	var index = this.packagelist.length;
			// 	if(index==28){
			// 		this.$nextTick(function() {
			// 			that.$refs.packagetable.getExpends(index, that.isexpand);
			// 		});
			// 	}
			// }
			//console.log('gridscroll',e);
		},
		gridsort(e) {
			console.log('gridsort', e);
		},
		// gridexpand(e) {//切换折叠/展开显示
		// 	var sondatalist=[
		// 					{
		// 						p_batch: '1120224955',
		// 						groupid: 'SYS000000087',
		// 						p_mode: '测试口岸',
		// 						expresscom: '亿龙达',
		// 						expressid: '794688196360',
		// 						cname: '',
		// 						taxid: '',
		// 						u_account: '13250503808',
		// 						u_createtime: '2021-11-20 09:49:55',
		// 						tablename: 'sp_pt_printlist_ls'
		// 					},
		// 					{
		// 						p_batch: '1120224920',
		// 						groupid: 'SYS000000088',
		// 						p_mode: '测试口岸',
		// 						expresscom: '',
		// 						expressid: '',
		// 						cname: '',
		// 						taxid: '',
		// 						u_account: '13250503808',
		// 						u_createtime: '2021-11-20 09:49:20',
		// 						tablename: 'sp_pt_printlist_ls'
		// 					}
		// 				];
		// 	if (e.row.expand) {
		// 		if (e.row.index == '26')
		// 			e.row.sonDataList =JSON.parse(JSON.stringify(sondatalist));
		// 		else if (e.row.index == '25')
		// 			e.row.sonDataList = JSON.parse(JSON.stringify(sondatalist));
		// 		else if (e.row.index == '30')
		// 			e.row.sonDataList =JSON.parse(JSON.stringify(sondatalist));
		// 		else {
		// 			e.row.expand = false;
		// 			//this.$refs.packagetable.getExpendsRow(row, row.expand);
		// 		}
		// 		console.log('list',JSON.stringify(this.packagelist));
		// 	}

		// },
		// getExpendsRow(row,expand){
		// 	row.expand=expand;
		// 	var sondatalist=[
		// 			{
		// 				p_batch: '1120224955',
		// 				groupid: 'SYS000000087',
		// 				p_mode: '测试口岸',
		// 				expresscom: '亿龙达',
		// 				expressid: '794688196360',
		// 				cname: '',
		// 				taxid: '',
		// 				u_account: '13250503808',
		// 				u_createtime: '2021-11-20 09:49:55',
		// 				tablename: 'sp_pt_printlist_ls'
		// 			},
		// 			{
		// 				p_batch: '1120224920',
		// 				groupid: 'SYS000000088',
		// 				p_mode: '测试口岸',
		// 				expresscom: '',
		// 				expressid: '',
		// 				cname: '',
		// 				taxid: '',
		// 				u_account: '13250503808',
		// 				u_createtime: '2021-11-20 09:49:20',
		// 				tablename: 'sp_pt_printlist_ls'
		// 			}
		// 		];
		// 	if ((row.index == '25'||row.index=='30')&&expand){
		// 		this.expands.push(row.index);
		// 		row.sonDataList =JSON.parse(JSON.stringify(sondatalist));
		// 	}
		// 	else{
		// 		row.expand=false;
		// 	}
		// },
		getExpandsRow(e) {
			e.row.expand = e.expand;
			var sondatalist = [
				{
					p_batch: '1120224955',
					groupid: 'SYS000000087',
					p_mode: '测试口岸',
					expresscom: '亿龙达',
					expressid: '794688196360',
					cname: '',
					taxid: '',
					u_account: '13250503808',
					u_createtime: '2021-11-20 09:49:55',
					tablename: 'sp_pt_printlist_ls'
				},
				{
					p_batch: '1120224920',
					groupid: 'SYS000000088',
					p_mode: '测试口岸',
					expresscom: '',
					expressid: '',
					cname: '',
					taxid: '',
					u_account: '13250503808',
					u_createtime: '2021-11-20 09:49:20',
					tablename: 'sp_pt_printlist_ls'
				}
			];
			if ((e.row.index == '25' || e.row.index == '26' || e.row.index == '30') && e.expand) {
				e.row.sonDataList = JSON.parse(JSON.stringify(sondatalist));
			}
			// else{
			// 	e.row.expand=false;
			// }
		}
	}
};
</script>
<style>
.el-table__expand-icon > .el-icon {
	display: none;
}
</style>
